<template>
  <div>
    <v-row no-gutters justify="end" align="center">
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn icon v-on="on" @click="refreshData">
            <v-icon>
              autorenew
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ $tc('refresh') }}
        </span>
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn
            icon
            :disabled="p11Info.dns1 !== '' && p11Info.dns2 !== ''"
            v-on="on"
            @click="openAddModal"
          >
            <v-icon>
              add
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ $tc('add_ip') }}
        </span>
      </v-tooltip>
    </v-row>

    <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
      <dns-table @deleteAddr="openIpDeleteModal" />
    </v-card>

    <new-dns-modal
      :open="showAddModal"
      @close="closeAddModal"
    />

    <dns-delete-modal
      :ip="addr"
      :open="showIpDeleteModal"
      @close="closeIpDeleteModal"
    />
  </div>
</template>

<script>
import DnsDeleteModal from './DnsDeleteModal.vue'
import NewDnsModal from './NewDnsModal.vue'
import DnsTable from './DnsTable.vue'

export default {
  components: {
    DnsTable,
    NewDnsModal,
    DnsDeleteModal
  },
  data () {
    return {
      status: false,
      showAddModal: false,
      addr: '',
      showIpDeleteModal: false
    }
  },
  computed: {
    p11Info () {
      return this.$store.state.hsm.p11Info
    }
  },
  methods: {
    loadDate () {
      this.$store.dispatch('hsm/getP11Info')
    },
    openAddModal () {
      this.showAddModal = true
    },
    closeAddModal () {
      this.loadDate()
      this.showAddModal = false
    },
    openIpDeleteModal (item) {
      this.addr = item.addr
      this.showIpDeleteModal = true
    },
    closeIpDeleteModal () {
      this.loadDate()
      this.showIpDeleteModal = false
    },
    refreshData () {
      this.loadDate()
    }
  }
}
</script>
